/*
    requires /js/at.js to be included
*/
import BaseUserInformationSection from './BaseUserInformationSection'
import BaseUserDataSection from './BaseUserDataSection'
import messageResource from '../../messageResource'
import {compareDates, escapeHtmlSymbols, formatRawSecondsOffset, trim} from '../../atUtils'
import {setFocusIntoFieldWithPlaceholder} from '../../atBrowserUtils'
import TimeZonesSelector from '../../controls/TimeZonesSelector'
import HireDateWarningDlg from './HireDateWarning'
import {UserManagementConstants} from 'constants'
import $ from 'jquery'
import _ from 'underscore'
import {GROUP_NEW_OR_NOT_KNOWN, ValidationErrors} from "../../panels/user/constants"
import Switcher from "../../components/Switcher"
import {MODE} from '../../panels/user/UserPanelContainer'
import SimpleListMenuButton from '../../SimpleListMenuButton'
import {setEventPreventHidingAllPanels} from '../../panels/utils'

class AccountInformationSection extends BaseUserInformationSection {
    constructor() {
        super()

        this.state = {
            accessToOtherProductEditable: false,
            enabledInOtherProduct: false,
            editSelf: false,
        }

        this.onStatePropertyChanged('accessToOtherProductEditable', editable => {
            this.$accessSelectorSeparator.toggle(this.mode === MODE.EDIT && editable)
            this.$accessToProductSelectorLabel.toggle(this.mode === MODE.EDIT)
            this.$accessToOtherProductSelectorLabel.toggle(this.mode === MODE.EDIT && editable)
            this.$accessToOnlyOtherProductSelectorLabel.toggle(this.mode === MODE.CREATE && editable)
            this.accessSelector.toggle(this.mode === MODE.EDIT)
            this.accessToOtherProductSelector.toggle(editable)
            this.$accessBoxRow.toggle(!this.state.editSelf && (this.mode === MODE.EDIT || editable))
        })

        this.onStatePropertyChanged('enabledInOtherProduct', enabled => {
            this.accessToOtherProductSelector.setState({enabled})
        })

        this.onStatePropertyChanged('editSelf', editSelf => {
            $(this.lightBoxEl).toggleClass('selfEdit', editSelf && this.mode === MODE.EDIT)
            this.$accessBoxRow.toggle(!editSelf && this.mode === MODE.EDIT)
        })
    }
}

AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN = GROUP_NEW_OR_NOT_KNOWN;

AccountInformationSection.prototype.init = function({
    mode = MODE.EDIT,
    lightBoxEl = null,
    userManagementData = null,
    currentTime = null,
    userId = null,
    accountSettings = null,
    changesCallback = () => {},
    validateCallback = () => {},
    checkUsernameErrorHandler = () => {},
    corporateSchedule = null,
    userGroupsEnabled = false,
    timeZoneGroupsEnabled = false,
    firstTTDate = null,
    firstLeaveRequestDate = null,
    editedUserIsSelf = false,
    handlerIfNoSuchUserAfterAjax = () => {},
    specificVersionDrawerConstructor = () => {},
    disableDuplicateUsernameCheck = false,
    disableEmptyUsernameCheck = false,
    scrollableContainerEl = null,
    showGroupRows = false,
    needValidation = true,
    hireDateLabelEl = null,
})
{
    this.mode = mode
    this.selfEdit = editedUserIsSelf
    this.isUGREnabled = userGroupsEnabled;
    this.isTZGEnabled = timeZoneGroupsEnabled;
    var self = this;
    var sectionId = "accountInformationSection";
    var userData = {
        firstName: accountSettings.firstName,
        lastName: accountSettings.lastName,
        middleName: accountSettings.middleInitial,
        email: accountSettings.email,
    };

    BaseUserInformationSection.prototype.init.call(this, {
        lightBoxEl,
        sectionId,
        userData,
        changesCallback,
        validateCallback,
        isInstantValidation: false,
        needValidation: needValidation,
    });

    this.specificFieldsDrawerController = specificVersionDrawerConstructor.init(
               {
                    lightBoxEl: lightBoxEl,
                    getElementByIdFunction: function ( subId ) {return self.getElementBySubId( subId )},
                    changeDetectedFunction: function ( notRequireConfirmationOnCopySettings ) {self.changesDetected( notRequireConfirmationOnCopySettings )},
                    updateUICallback: function (errors) {$.extend(self.errors, errors); self.updateUI()},
                    validationDetectedCallback: function () {self.validationDetected()},
                    handlerIfNoSuchUserAfterAjax: handlerIfNoSuchUserAfterAjax,
                    disableDuplicateUsernameCheck: disableDuplicateUsernameCheck && !needValidation,
                    disableEmptyUsernameCheck: disableEmptyUsernameCheck && !needValidation,
                    disableValidation: true,
                }
    );
    this.specificFieldsDrawerController.initFields({accountSettings : accountSettings,
                                         currentTime: currentTime, editedUserIsSelf: editedUserIsSelf} );
    this.userId = userId;
    this.corporateSchedule = corporateSchedule;

    this.scrollableContainerEl = scrollableContainerEl;

    this.savedPasswordData = accountSettings.passwordData;
    this.checkUsernameErrorHandler = checkUsernameErrorHandler;

    if (showGroupRows) {
        this.generateUserGroupFields(userManagementData, accountSettings);
        this.generateTimeZoneGroupFields(userManagementData, accountSettings);
    }

    this.$userDataTable = $(this.lightBoxEl).find(".userDataTable")

    this.$accessBoxRow = $(this.getElementBySubId("accessBoxRow"))
    this.$accessBoxRow.toggle(!this.selfEdit)

    this.accessSelector = this.createAccessSelector( "changeAccess",
                                                     accountSettings.enabled,
                                                     this.getElementBySubId( "accessSelectorPlaceholder" ) );

    this.$accessSelectorSeparator = this.$accessBoxRow.find('.accessSelectorSeparator')
    this.$accessToProductSelectorLabel = this.$accessBoxRow.find('.accessToProductSelectorLabel')
    this.$accessToOtherProductSelectorLabel = this.$accessBoxRow.find('.accessToOtherProductSelectorLabel')
    this.$accessToOnlyOtherProductSelectorLabel = this.$accessBoxRow.find('.accessToOnlyOtherProductSelectorLabel')
    this.accessToOtherProductSelector = this.createAccessSelector("changeAccessToOtherProduct",
        accountSettings.enabledInOtherProduct,
        this.getElementBySubId("accessToOtherProductSelectorPlaceholder") );

    this.delReleaseDateBtn = this.getElementBySubId("delReleaseDateBtn");

    this.hireDatePlaceholderEl = this.getElementBySubId("hireDatePlaceholder");
    this.hireDateLabelEl = hireDateLabelEl;
    this.updateHireDateSelector(userManagementData, accountSettings.hireDate);

    this.firstTTDate = firstTTDate;
    this.firstLeaveRequestDate = firstLeaveRequestDate;
    this.updateUI();

    this.callStateChangeHandlersWithCurrentState()

    return this;
};

AccountInformationSection.prototype.generateUserGroupFields = function(userManagementData, accountSettings) {
    this.newUserGroupNameField = this.$subId("newUserGroupNameField");
    this.newUserGroupNameField.off();
    this.setValue(this.newUserGroupNameField, "");
    this.newUserGroupNameField.attr("placeholder", messageResource.getMessage("user.add.js.user_group_selector.new_user_group_place_holder")).placeholder();
    this.newUserGroupNameField.blur(this.onBlurFieldHandler(() => {
        this._checkNewUserGroupNameValid(true);
        const name = trim(this.newUserGroupNameField.pVal());
        this.triggerUserGroupChanged(AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN, name);
    }));

    this.userGroupSelectorPlaceholderEl = this.getElementBySubId("userGroupSelectorPlaceholder");
    this.userGroupSelectorPlaceholderEl.innerHTML = "";

    this.newUserGroupNameDiv = this.getElementBySubId("newUserGroupNameDiv");
    this.userGroupSelector = null;
    this.updateUserGroupsVisibility(this.isUGREnabled);

    if (this.isUGREnabled && userManagementData.allUserGroups) {
        this.userGroupSelector = this.createUserGroupSelector(userManagementData.allUserGroups, accountSettings.userGroupId,
            this.userGroupSelectorPlaceholderEl);
        this.updateNewUserGroupFieldVisibility(accountSettings.userGroupId);
    }
}

AccountInformationSection.prototype.generateTimeZoneGroupFields = function(userManagementData, accountSettings) {
    this.newTimeZoneGroupNameField = this.$subId("newTimeZoneGroupNameField");
    this.newTimeZoneGroupNameField.off();
    this.setValue(this.newTimeZoneGroupNameField, "");
    this.newTimeZoneGroupNameField.attr("placeholder", messageResource.getMessage("user.add.js.time_zone_group_selector.new_time_zone_group_placeholder"))
        .placeholder();
    this.newTimeZoneGroupNameField.blur(this.onBlurFieldHandler(() => {
        this._checkNewTimeZoneGroupNameValid(true);
        this.triggerTimeZoneChanged(AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN)
    }));
    this.newTimeZoneGroupNameField.on("change", () => {
        const value = trim(this.value)
        if (this.prevValue !== value) {
            this.setDuplicateTimeZoneGroupError(false)
        }
        this.prevValue = value
    });

    this.timeZoneGroupSelectorPlaceholderEl = this.getElementBySubId("timeZoneGroupSelectorPlaceholder");
    this.timeZoneGroupSelectorPlaceholderEl.innerHTML = "";

    this.timeZonesSelectorPlaceholderEl = this.getElementBySubId("timeZonesSelectorPlaceholder");
    this.timeZonesSelectorPlaceholderEl.innerHTML = "";

    this.timeZoneGroupSelector = null;
    this.timeZonesSelector = null;

    this.updateTimeZoneGroupsVisibility(this.isTZGEnabled);

    if (this.isTZGEnabled && userManagementData.allTimeZoneGroups) {
        this.timeZoneGroupSelector = this.createTimeZoneGroupSelector(userManagementData.allTimeZoneGroups, accountSettings.timeZoneGroupId,
            this.timeZoneGroupSelectorPlaceholderEl);
        this.updateTimeZoneSelectorVisibility(accountSettings.timeZoneGroupId);
        this.timeZonesSelector = this.createTimeZonesSelector();
    }
}

AccountInformationSection.prototype.toggleHireDateChangedWrning = function(show) {
    if (show) {
        this.getHireDateChangedWarning().showAt(
            $(this.getElementBySubId("hireDate")),
            "userlist.user_popup.hire_date_changed.integrated",
            this.getPreviousHireDate(),
            this.getHireDate()
        )
    } else {
        this.getHireDateChangedWarning().hide()
    }
}

AccountInformationSection.prototype.updateHireDateSelector = function(userManagementData, hireDate, hireDateEditable = true) {

    var self = this;
    this.hireDatePlaceholderEl = this.getElementBySubId("hireDatePlaceholder");
    $(this.hireDatePlaceholderEl).click((e) => setEventPreventHidingAllPanels(e))

    this.hireDateSelector = this.createDateSelector(
        userManagementData,
        "hireDate",
        this.hireDatePlaceholderEl,
        hireDate,
        this.corporateSchedule,
        () => {
            if (self._checkHireDateIsValid()) $(this).trigger('hireDateChanged', [this.getHireDate()])
            self.updateUI()
        },
        hireDateEditable,
    );

}

AccountInformationSection.prototype.setReadOnly = function(readOnly) {
    BaseUserInformationSection.prototype.setReadOnly.call(this, readOnly);
    this.$userDataTable.toggleClass("readOnly", readOnly);
}

AccountInformationSection.prototype.triggerTimeZoneChanged = function(id) {
    $(this).trigger("timeZoneGroupChanged", [id, this.getNewTimeZoneGroup()])
}

AccountInformationSection.prototype.triggerUserGroupChanged = function(id) {
    $(this).trigger("userGroupChanged", [id, this.getNewUserGroupName()]);
}

AccountInformationSection.prototype.getSpecificValues = function(){
   return  this.specificFieldsDrawerController ?  this.specificFieldsDrawerController.getSpecificValues() : {};
};

AccountInformationSection.prototype.getSpecificNotCopyValues = function(){
    return  this.specificFieldsDrawerController ?  this.specificFieldsDrawerController.getNotCopyValues() : {};
};

AccountInformationSection.prototype.validationDetected = function ()
{
    if (this.specificFieldsDrawerController)  $.extend(this.errors, this.specificFieldsDrawerController.getErrors());
    BaseUserDataSection.prototype.validationDetected.call(this);
};

AccountInformationSection.prototype.createDateSelector = function( userManagementData, name, renderTo, strDate, corporateSchedule,
                                                                   onChange, isEditable )
{
    var date = strDate && strDate.length > 0 ? strDate.parseJSONDate() : null;
    var renderToPlaceholder = $(renderTo)[0];
    var cellValue = date;
    var calendarValue = date;

    var self = this;
    var calendar = window.ClassicBridge.integrateCalendar(renderToPlaceholder, {
        onSelect: function (date) {
            calendarValue = Date.parseJSONDate(date);
            cellValue = calendarValue;
            calendar.setProps({ selectedDay: calendarValue, placeholder: '' });
            if (onChange) onChange(undefined, date);
            self.changesDetected(true);
        },
        selectedDay: date ? calendarValue : currentUserTime(),
        placeholder: !date && messageResource.getMessage("common.date_selector.select_date"),
        type: 'day',
        disabled: !isEditable,
    })
    calendar.serverHireDate = date;
    calendar.previousDate = date;

    calendar.unsetValue = function() {
        cellValue = null;
        calendar.setProps({ placeholder: messageResource.getMessage("common.date_selector.select_date") });
    }

    calendar.fireEvent = function() {
        if (onChange) onChange(undefined, cellValue);
    }

    calendar.getValue = function() {
        return cellValue;
    }

    calendar.setValue = function(value) {
        calendarValue = value;
        cellValue = value;
        calendar.setProps({
            selectedDay: value,
            placeholder: !value && messageResource.getMessage("common.date_selector.select_date"),
        });
    }

    calendar.hide = function() {
        calendar.remove();
    }

    calendar.formatDate = function() {
    }

    return calendar;
};

AccountInformationSection.prototype.sectionWasLoaded = function()
{
    this._nameChanged();
};

AccountInformationSection.prototype.createAccessSelector = function(eventname, currentUserAccess, renderTo )
{
    const $renderTo = $(renderTo);
    $renderTo.empty();
    const switcher = new Switcher({
        additionalClass: 'small',
        onSwitchCallback: (enabled) => {
            this.changesDetected( true );
            $(this).trigger(eventname, [enabled]);
        }
    }).init($renderTo);
    switcher.setState({
        enabled: !!currentUserAccess
    })
    return switcher;
};

AccountInformationSection.prototype.getHireDateChangedWarning = function()
{
    if (_.isUndefined(this.hireDateChangedWarning))
    {
        this.hireDateChangedWarning = new HireDateWarningDlg(
                $(this.lightBoxEl),
                $(this.lightBoxEl).find(".innerContent"),
                (isConfirmed) =>
                {
                    if (isConfirmed) {
                        $(this).trigger('hireDateForceChanged', [this.getHireDate()])
                    } else {
                        this.setHireDate(this.getPreviousHireDate())
                    }
                    $(this).trigger('setHasLeavesOrTTBeforeNewHireDateError', [false])
                }).init()
    }
    return this.hireDateChangedWarning;
};

AccountInformationSection.prototype.createUserGroupSelector = function(userGroups, selectedGroupId, renderTo) {
    const userGroupNotAssignedGroup = {
        name: messageResource.getMessage("user.add.js.user_group_selector.user_group_not_selected_item_title"),
        id: UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID
    }

    const newUserGroupGroup = {
        name: messageResource.getMessage("user.add.js.user_group_selector.new_user_group_item_title"),
        id: AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN
    }

    const listItems = [userGroupNotAssignedGroup, newUserGroupGroup].concat(userGroups)
    const escapedListItems = listItems.map(item => ({id: item.id, name: escapeHtmlSymbols(item.name)}))

    const selector = new SimpleListMenuButton({
        itemHtmlCallback: item => item.name,
        extraClass: 'components_userGroupSelectorMenu',
        onSelect: (item) => {
            this.updateNewUserGroupFieldVisibility(item.id)
            this.changesDetected()
            this.validationDetected()
            this.triggerUserGroupChanged(item.id)
        },
        itemHeight: 28,
    }).init($(renderTo))

    const selectedItem = escapedListItems.find(item => item.id === selectedGroupId)
    selector.setItems(escapedListItems, selectedItem || escapedListItems[0])

    return selector
}

AccountInformationSection.prototype.createTimeZoneGroupSelector = function(timeZoneGroups, selectedTimeZoneGroupId, renderTo) {
    const newTimeZoneGroupGroup = {
        name: messageResource.getMessage("user.add.js.time_zone_group_selector.new_time_zone_group_item_title"),
        id: AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN
    }

    const listItems = [newTimeZoneGroupGroup].concat(timeZoneGroups)
    const escapedListItems = listItems.map(item => ({id: item.id, name: escapeHtmlSymbols(item.name), rawOffset: item.rawOffset}))

    const selector = new SimpleListMenuButton({
        itemHtmlCallback: item => {
            if (item.id === AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN) {
                return `<span class="nameGroup">${item.name}</spreturn>`
            } else {
                return `<span class="nameGroup">${item.name}</span> <span class="offset">${messageResource.getMessage("time_zones_selector.js.gmt",
                    [formatRawSecondsOffset(item.rawOffset)])}</span>`
            }
        },
        extraClass: 'components_userPanel_timeZoneGroupSelectorMenu',
        onSelect: item => {
            this.setDuplicateTimeZoneGroupError(false)
            this.updateTimeZoneSelectorVisibility(item.id)
            this.changesDetected()
            this.validationDetected()
            if (item.id !== AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN)
                this.triggerTimeZoneChanged(item.id)
        },
        itemHeight: 28,
    }).init($(renderTo))

    const selectedItem = escapedListItems.find(item => item.id === selectedTimeZoneGroupId)
    selector.setItems(escapedListItems, selectedItem || escapedListItems[0])

    return selector
}

AccountInformationSection.prototype.createTimeZonesSelector = function()
{
    var self = this;
    this.timeZonesSelectorPlaceholderEl.innerHTML = "";
    var selector =  new TimeZonesSelector().init(
            $('#' + this.timeZonesSelectorPlaceholderEl.id),
            null,
            function(data) { self._cityChanged(data); },
            messageResource.getMessage('user.add.js.time_zone_group_selector.select_city_placeholder'),
            false,
            "userPopupSearch"
    );
    $(this.lightBoxEl).find(".innerContent")
                 .off("scroll.userPopupTZSelector")
                 .on("scroll.userPopupTZSelector", function()
                 {
                     selector.cancelSearch();
                 });
    return selector;
};

AccountInformationSection.prototype._cityChanged = function(cityData)
{
    this.cityData = cityData;
    this.updateTimeZoneSelectorVisibility(this.timeZoneGroupSelector.getSelectedItem().id)
    if (this.newTimeZoneGroupNameField.pVal() === '')
        this.newTimeZoneGroupNameField.pVal(this.cityData.name.substring(0, 40));
    this._checkCityDataValid();
    this._checkNewTimeZoneGroupNameValid(true);
    this.triggerTimeZoneChanged(AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN);
    this.updateUI();
    this.validationDetected();
};

AccountInformationSection.prototype._checkNewUserGroupNameValid = function( onlyRemoveEmptyError )
{
    if (this._isNewUserGroupFieldActive())
    {
        this._checkEmpty( this.newUserGroupNameField, ValidationErrors.NEW_USER_GROUP_EMPTY, onlyRemoveEmptyError );
    }
};

AccountInformationSection.prototype.setDuplicateTimeZoneGroupError = function(value)
{
    this.errors[ValidationErrors.DUPLICATE_TIME_ZONE_GROUP] = value;
    this.updateUI();
};

AccountInformationSection.prototype.updateTimeZoneGroups = function(timeZoneGroups, selectedId)
{
    var _selectedId =  _.isUndefined(selectedId) ? AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN : selectedId;
    this.timeZoneGroupSelectorPlaceholderEl.innerHTML = "";
    this.timeZoneGroupSelector = this.createTimeZoneGroupSelector(
            timeZoneGroups, _selectedId, this.timeZoneGroupSelectorPlaceholderEl );
};

AccountInformationSection.prototype.updateUserGroups = function(groups, selectedId)
{
    this.userGroupSelectorPlaceholderEl.innerHTML = "";
    this.userGroupSelector = this.createUserGroupSelector( groups, selectedId, this.userGroupSelectorPlaceholderEl );
    this.updateNewUserGroupFieldVisibility( selectedId );
};

AccountInformationSection.prototype._checkNewTimeZoneGroupNameValid = function( onlyRemoveEmptyError )
{
    if (this._isNewTimeZoneGroupFieldActive())
        this._checkEmpty( this.newTimeZoneGroupNameField, ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY, onlyRemoveEmptyError );
};

AccountInformationSection.prototype._checkCityDataValid = function() {
    this.errors[ValidationErrors.CITY_DATA_EMPTY] = false
    this.errors[ValidationErrors.DUPLICATE_TIME_ZONE_GROUP] = false

    if (this.timeZoneGroupSelector != null
        && this.timeZoneGroupSelector.getSelectedItem().id === AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN
        && this.cityData == null)
        this.errors[ValidationErrors.CITY_DATA_EMPTY] = true
}

AccountInformationSection.prototype._checkHireDateIsValid = function()
{
    this.errors[ValidationErrors.HIRE_DATE_EMPTY] = false;
    this.errors[ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF] = false;

    if( this.getHireDate() == null )
    {
        this.errors[ValidationErrors.HIRE_DATE_EMPTY] = true;
        return false;
    }

    if( this.editedUserIsSelf && compareDates( this.getHireDate(), window.currentUserTime() ) > 0 )
    {
        this.errors[ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF] = true;
        return false;
    }

    return true;
};

AccountInformationSection.prototype.customValidate = function(oldErrors)
{
    $.extend( this.errors, this.specificFieldsDrawerController.validateFields( oldErrors, this.checkEmpty ) );
    this._checkNewUserGroupNameValid();
    this._checkCityDataValid();
    this._checkNewTimeZoneGroupNameValid();
    this._checkHireDateIsValid();
};

AccountInformationSection.prototype.updateUserGroupsVisibility = function(isUGREnabled)
{
    this.getElementBySubId("userGroupRow").style.display = isUGREnabled ? "block" : "none";
};

AccountInformationSection.prototype.updateTimeZoneGroupsVisibility = function(isTZGEnabled)
{
    this.getElementBySubId("timeZoneGroupRow").style.display = isTZGEnabled ? "block" : "none";
};

AccountInformationSection.prototype.updateNewUserGroupFieldVisibility = function( selectedGroupId )
{
    var showNewGroupField = this.userGroupSelector != null && selectedGroupId == AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
    this.newUserGroupNameDiv.style.display = showNewGroupField ? "inline-block" : "none";
    $(this.getElementBySubId("userGroupRow")).toggleClass("showNewGroupField", showNewGroupField);
};

AccountInformationSection.prototype.updateTimeZoneSelectorVisibility = function( selectedGroupId )
{
    var showTimeZonesSelector = this.timeZoneGroupSelector != null && selectedGroupId == AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
    $(this.getElementBySubId("timeZoneGroupRow")).toggleClass("showTimeZonesSelector", showTimeZonesSelector);
    this.updateNewTimeZoneGroupFieldVisibility(selectedGroupId);
};

AccountInformationSection.prototype.updateNewTimeZoneGroupFieldVisibility = function( selectedGroupId )
{
    var showTimeZonesSelector = this.timeZoneGroupSelector != null && selectedGroupId == AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
    var showNewTimeZoneGroupField = showTimeZonesSelector && this.cityData != null;
    $(this.getElementBySubId("timeZoneGroupRow")).toggleClass("showNewTimeZoneGroupField", showNewTimeZoneGroupField);
};

AccountInformationSection.prototype._isNewUserGroupFieldActive = function()
{
    return this.userGroupSelector != null && this.newUserGroupNameDiv.style.display != "none";
};

AccountInformationSection.prototype._isNewTimeZoneDataActive = function() {
    return !!this.timeZoneGroupSelector && this.timeZoneGroupSelector.getSelectedItem().id === AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN
}

AccountInformationSection.prototype._isNewTimeZoneGroupFieldActive = function()
{
    return this._isNewTimeZoneDataActive() && this.cityData != null;
};

AccountInformationSection.prototype.getNewUserGroupName = function() {
    if (!this.userGroupSelector)
        return null
    if (this.userGroupSelector.getSelectedItem().id !== AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN)
        return null
    return this.newUserGroupNameField.pVal()
}

AccountInformationSection.prototype.getNewTimeZoneGroup = function()
{
    if (!this.timeZoneGroupSelector)
        return null;
    if (this.timeZoneGroupSelector.getSelectedItem().id !== AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN)
        return null;
    if (!this.cityData)
        return null;
    return {
        id: GROUP_NEW_OR_NOT_KNOWN,
        name: this.newTimeZoneGroupNameField.pVal(),
        cityPlaceId: this.cityData.placeId,
        cityName: this.cityData.name,
        timeZoneId: this.cityData.timeZoneId
    };
};

AccountInformationSection.prototype.getUserId = function()
{
    return this.userId;
};

AccountInformationSection.prototype.isEnabled = function()
{
    return this.accessSelector.getState().enabled;
};

AccountInformationSection.prototype.isEnabledInOtherProduct = function()
{
    return this.accessToOtherProductSelector.getState().enabled;
};

AccountInformationSection.prototype.getUserGroupId = function() {
    return this.userGroupSelector ? this.userGroupSelector.getSelectedItem().id : AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN
}

AccountInformationSection.prototype.getTimeZoneGroupId = function() {
    return this.timeZoneGroupSelector ? this.timeZoneGroupSelector.getSelectedItem().id : AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN
}

AccountInformationSection.prototype.getHireDate = function()
{
    return this.hireDateSelector.getValue();
};

AccountInformationSection.prototype.setHireDate = function(date)
{
    this.setPreviousHireDate(date);
    this._setHireDateLabel(date)
    return this.hireDateSelector.setValue(date);
};


AccountInformationSection.prototype.getPreviousHireDate = function()
{
    return this.hireDateSelector.previousDate;
};

AccountInformationSection.prototype._setHireDateLabel = function(date)
{
    if (!!date)
        this.hireDateLabelEl.text(this.hireDateSelector.formatDate(date))
};

AccountInformationSection.prototype.getServerHireDate = function()
{
    return this.hireDateSelector.serverHireDate;
};

AccountInformationSection.prototype.setPreviousHireDate = function(date)
{
    this.hireDateSelector.previousDate = date;
    this.hireDateSelector.setProps({ selectedDay: date });
};

AccountInformationSection.prototype.getReleaseDate = function()
{
   return null;
};

AccountInformationSection.prototype.setReleaseDate = function(date) {};

AccountInformationSection.prototype.hasErrors = function ()
{
    var ignoredErrors = [];
    if (!this._isNewUserGroupFieldActive())
    {
        ignoredErrors.push(ValidationErrors.NEW_USER_GROUP_EMPTY);
    }
    if (!this._isNewTimeZoneDataActive())
    {
        ignoredErrors.push(ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY);
        ignoredErrors.push(ValidationErrors.CITY_DATA_EMPTY);
    }
    //noinspection LoopStatementThatDoesntLoopJS
    for( var prop in this.errors )
    {
        if( this.errors[prop] && ignoredErrors.indexOf(prop) < 0 )
        {
            return true;
        }
    }
    return false;
};

AccountInformationSection.prototype.getErrorState = function(  )
{
    var errors = $.extend({}, this.errors);
    errors[ValidationErrors.NEW_USER_GROUP_EMPTY] = false;
    errors[ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY] = false;
    errors[ValidationErrors.CITY_DATA_EMPTY] = false;
    return errors;
};

AccountInformationSection.prototype.setErrorState = function( errors, passwordValidationJson ) //todo: maybe put passwordValidationJson into error map?
{
    // Errors can be taken from state and then they change in this class. Copy is created to avoid a possible state changes
    this.errors = {...errors};
    this.specificFieldsDrawerController.setErrorState(errors, passwordValidationJson);
    this.updateUI();
};

AccountInformationSection.prototype.setFocusIntoFirstNameField = function()
{
    setFocusIntoFieldWithPlaceholder( this.firstNameField );
};

AccountInformationSection.prototype.setToDuplicateUsernameState = function(){
    if(this.specificFieldsDrawerController)
    {
        this.specificFieldsDrawerController.userNameDrawer._checkUsernameDuplicatesCallback( true );
    }
};

AccountInformationSection.prototype.setLoaded = function(loaded) {
    this.accessSelector.setState({animated: loaded})
    this.accessToOtherProductSelector.setState({animated: loaded})
}
export default AccountInformationSection



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/AccountInformationSection.js